<template>
  <button
    class="dropdown-item d-flex align-items-center justify-content-between"
    @click="signout"
  >
    <span class="me-2">Log out</span>
    <i class="fa-solid fa-arrow-right-from-bracket text-muted"></i>
  </button>
</template>

<script>
export default {
  name: "SignOut",

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {
    signout() {
      this.$store.state.modules.api
        .signout(JSON.parse(localStorage.account).token)
        .then(() => {
          this.$store.state.modules.account.user = undefined;
          this.$store.state.modules.account.token = undefined;
          this.$store.state.utils.setNewNotifications(
            {
              type: "warning",
              message: "You signed out successfully!",
            },
            2500
          );
          if (this.$route.name !== "Home") {
            this.$router.push({ name: "Home" });
          }
        });
    },
  },
};
</script>

<style></style>
